import {useEventContext} from "../../contexts/EventContext";
import {useTranslations} from "../../contexts/TranslationsContext";
import unescape from 'unescape';
import {LabelWrapper, Label, Tooltip} from './';
import Skeleton from "react-loading-skeleton";
import {useEffect, useState} from "preact/hooks";
import {format} from '../../utils/Date'
import {isEmpty} from "lodash/lang";

function AvailableStartDates() {
    const { selectedCourseType, periods, setSelectedStartDate, setSelectedPeriod } = useEventContext();
    const { tooltips } = useTranslations();
    const [options, setOptions] = useState([]);

    useEffect(() => {
        if (Object.keys(periods).length !== 0 && Array.isArray(periods[selectedCourseType])) {
            const mappedOptions = periods[selectedCourseType].map(period => {
                return {
                    period,
                    value: period.start_date,
                    label: format(period.start_date),
                    sold_out: hasSoldOut(period.event_period_options)
                }
            });


            setOptions(mappedOptions);
            const available = mappedOptions.filter((option) => {
                return !option.sold_out;
            });
            if(available.length > 0){
                setSelectedStartDate(available[0].value);
                setSelectedPeriod(available[0].period);
            }else{
                setSelectedStartDate(mappedOptions[0].value);
            }
        }
    }, [selectedCourseType]);

    let label = tooltips.startDates.title.one;

    if (options.length > 0) {
        label = tooltips.startDates.title.other;
    }
    const hasSoldOut = (periodOptions) => {
        if (periodOptions.length > 0) {
           const available = periodOptions.filter((option) => {
                    return !option.hidden && option.has_quantity_available;
                });
            console.log(available)
            return isEmpty(available);
        }
        return false;
    };
    return (
        <>
            <LabelWrapper>
                <Label>{unescape(label, 'all')}</Label>
                <Tooltip name="startDates" title={label} />
            </LabelWrapper>
            <div className="esc-ii-flex esc-ii-flex-col esc-ii-space-y-2.5">
                {
                    options.length > 0 ?
                        <select
                            isp_ignore
                            className="esc-ii-border-2 esc-ii-py-4 esc-ii-px-4 esc-ii-rounded esc-ii-border-secondary esc-ii-font-montserrat esc-ii-text-xs lg:esc-ii-text-sm focus:esc-ii-outline-none focus:esc-ii-ring-primary focus:esc-ii-border-primary"
                            onChange={(event) => {
                                setSelectedStartDate(options[event.target.value].value);
                                setSelectedPeriod(options[event.target.value].period)
                            }}
                        >
                            {
                                options.map((option, index) => (
                                    <option disabled={option.sold_out} value={index}>{option.label}{option.sold_out && " - Sold out"}</option>
                                ))
                            }
                        </select>
                        :
                        <Skeleton />
                }
            </div>
        </>
    );
}

export default AvailableStartDates;
